import { useSelector } from 'react-redux';

// Shown on the manual reminder send controls when a tenancy has scheduler-service's PauseSending
// flag set. Scheduled reminders are stopped server side (BD-775); these controls are disabled in the
// UI only, so keep the wording pointed at how to resume rather than implying a hard block.
export const EMAILS_PAUSED_MESSAGE = "Email sending is paused for this tenancy. Resume it in Settings to send reminders.";

// Simple hook to get tenancy lookup from Redux
export const useTenancyLookup = () => {
    const tenancyLookup = useSelector((state) => state.tenancy.tenancyLookup);

    return {
        tenancyLookup,
        resolveTenancyName: (tenancyId) => {    
            const id = parseInt(tenancyId, 10);
            return tenancyLookup[id] || `Tenancy ${tenancyId}`;
        }
    };
};
